import { convertTime } from 'containers/inProgressPage/helpers/convertTime';

export const displaySectionTime = section => {
  return section.is_timed
    ? convertTime(section.time_allowed_seconds)
    : section.slot_durations_total !== null
    ? convertTime(section.slot_durations_total)
    : 'unlimited';
};
